import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { GlobalService } from "src/app/services/global/global.service";
import { USERStoreService } from "src/app/services/user/user-store.service";

@Component({
	selector: "app-profile",
	templateUrl: "./profile.component.html",
	styleUrls: ["./profile.component.css"]
})
export class ProfileComponent implements OnInit {
	constructor(
		public router: Router,
		public userStoreService: USERStoreService,
		public globalService: GlobalService
	) {}

	ngOnInit() {}
	public cancel() {
		this.back();
	}
	public back() {
		const url = this.globalService.userActionCallFrom.replace("/", "");
		this.router.navigate([url], { skipLocationChange: true });
	}
	public userAction(type) {
		switch (type) {
			case "contactInfo":
				this.router.navigate(["contact-info"], { skipLocationChange: true });
				break;
			case "notifications":
				this.router.navigate(["notifications"], { skipLocationChange: true });
				break;
			case "paymentMethod":
				this.router.navigate(["payment-methods"], { skipLocationChange: true });
				break;
			case "billingAccount":
				this.router.navigate(["billing-account"], { skipLocationChange: true });
				break;
			default:
		}
	}
}
